import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseFormContainer from '../../components/BaseFormContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});

export default function VerificationEmailSent() {
  const navigate = useNavigate();

  return (
    <BackgroundContainer>
      <BaseFormContainer>
        <BaseHeader sx={{ fontSize: '2rem' }}>Check Your Email</BaseHeader>
        <Subtitle sx={{
          marginBottom: '20px',
          fontSize: '1.2rem',
          '@media (max-width: 400px)': { fontSize: '1.1rem' },
          '@media (max-width: 360px)': { fontSize: '1rem' },
          '@media (max-width: 320px)': { fontSize: '0.95rem' },
        }}>
          A verification link has been sent to your email address. Please check your inbox and click the link to confirm.
        </Subtitle>
        <BaseButton onClick={() => navigate('/')}>Back to Home</BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>
  );
}
